export const commonVar = {
  LOCATION_TYPE_HOME_ID: "PC009.2",
  STATE_LIST: [
    "AL",
    "AK",
    "AZ",
    "AR",
    "CA",
    "CO",
    "CT",
    "DE",
    "FL",
    "GA",
    "HI",
    "ID",
    "IL",
    "IN",
    "IA",
    "KS",
    "KY",
    "LA",
    "ME",
    "MD",
    "MA",
    "MI",
    "MN",
    "MS",
    "MO",
    "MT",
    "NE",
    "NV",
    "NH",
    "NJ",
    "NM",
    "NY",
    "NC",
    "ND",
    "OH",
    "OK",
    "OR",
    "PA",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VT",
    "VA",
    "WA",
    "WV",
    "WI",
    "WY",
  ],
  // CO-3898 (epic CO-2315, Payer Foundation F1.S1): two-letter code -> full state
  // name, for surfaces that must SHOW a state rather than select one. The Payers
  // list's Coverage Detail column reads "California FFS", not "CA FFS".
  //
  // Keys are exactly STATE_LIST above and must stay that way - a payer's state can
  // only ever be one of those, and common.spec.ts asserts the two are 1:1 so a code
  // added to one without the other fails a test rather than rendering a bare code.
  STATE_NAMES: {
    AL: "Alabama",
    AK: "Alaska",
    AZ: "Arizona",
    AR: "Arkansas",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DE: "Delaware",
    FL: "Florida",
    GA: "Georgia",
    HI: "Hawaii",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    IA: "Iowa",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    ME: "Maine",
    MD: "Maryland",
    MA: "Massachusetts",
    MI: "Michigan",
    MN: "Minnesota",
    MS: "Mississippi",
    MO: "Missouri",
    MT: "Montana",
    NE: "Nebraska",
    NV: "Nevada",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NY: "New York",
    NC: "North Carolina",
    ND: "North Dakota",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VT: "Vermont",
    VA: "Virginia",
    WA: "Washington",
    WV: "West Virginia",
    WI: "Wisconsin",
    WY: "Wyoming",
  },
  FACILITY_TYPES: [
    {
      display: "Q5001 - Home/Residence",
      value: "HOME",
    },
    {
      display: "Q5002 - Assisted Living Facility",
      value: "ASSISTED_LIVING_FACILITY",
    },
    {
      display: "Q5003 - Long Term Care or Non-Skilled Nursing",
      value: "NURSING_HOME",
    },
    {
      display: "Q5004 - Skilled Nursing Facility",
      value: "SKILLED_NURSING_FACILITY",
    },
    {
      display: "Q5005 - Inpatient Hospital ",
      value: "INPATIENT_HOSPITAL",
    },
    {
      display: "Q5006 - Inpatient Hospice Facility",
      value: "INPATIENT_HOSPICE_FACILITY",
    },
    {
      display: "Q5007 - Long Term Care Hospital",
      value: "LONG_TERM_CARE_HOSPITAL",
    },
    {
      display: "Q5008 - Inpatient Psychiatric Facility",
      value: "INPATIENT_PSYCHIATRIC_FACILITY",
    },
    {
      display: "Q5009 - Place not otherwise specified",
      value: "UNSPECIFIED",
    },
    {
      display: "Q5010 - Hospice Residential Facility",
      value: "HOSPICE_RESIDENTIAL_FACILITY",
    },
  ],

  STATUS_MAPPING: {
    EVALUATION: "referral",
    REFERRAL: "referral",
    ON_SERVICE: "patient",
    DISCHARGED: "discharge",
    CANCELLED: "cancelled",
  },
  REFERRAL_TYPE: ["CALL", "EMAIL", "FAX", "Other"],
  PATIENT_STATUS_OPTIONS: [
    "All",
    "On-Service",
    "Referral",
    "Discharged",
    "Cancelled",
    "Evaluation",
  ],
  DEFAULT_PATIENT_STATUS: "On-Service",
  REFERRAL_SEARCH_BY: {
    All: "All",
    Evaluation: "Evaluation",
    Referrals: "Referral",
    Patients: "On-Service",
    Discharges: "Discharged",
    Cancelled: "Cancelled",
  },
  REFERRAL_SEARCH_BY_VALUE: {
    All: "All",
    Evaluation: "Evaluation",
    Referral: "Referrals",
    On_Service: "Patients",
    Discharged: "Discharges",
    Cancelled: "Cancelled",
  },
  ETHNICITIES: [
    "American Indian or Alaska Native",
    "Asian",
    "Black or African American",
    "Hispanic or Latino",
    "Native Hawaiian or Other Pacific Islander",
    "White",
  ],
  COUNTRIES: [
    "United States",
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Anguilla",
    "Antigua & Barbuda",
    "Argentina",
    "Armenia",
    "Aruba",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Bolivia",
    "Bosnia & Herzegovina",
    "Botswana",
    "Brazil",
    "British Virgin Islands",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cambodia",
    "Cameroon",
    "Cape Verde",
    "Cayman Islands",
    "Chad",
    "Chile",
    "China",
    "Colombia",
    "Congo",
    "Cook Islands",
    "Costa Rica",
    "Cote D Ivoire",
    "Croatia",
    "Cruise Ship",
    "Cuba",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Estonia",
    "Ethiopia",
    "Falkland Islands",
    "Faroe Islands",
    "Fiji",
    "Finland",
    "France",
    "French Polynesia",
    "French West Indies",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Greenland",
    "Grenada",
    "Guam",
    "Guatemala",
    "Guernsey",
    "Guinea",
    "Guinea Bissau",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hong Kong",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Isle of Man",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jersey",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kuwait",
    "Kyrgyz Republic",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macau",
    "Macedonia",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Mauritania",
    "Mauritius",
    "Mexico",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Namibia",
    "Nepal",
    "Netherlands",
    "Netherlands Antilles",
    "New Caledonia",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Norway",
    "Oman",
    "Pakistan",
    "Palestine",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Puerto Rico",
    "Qatar",
    "Reunion",
    "Romania",
    "Russia",
    "Rwanda",
    "Saint Pierre & Miquelon",
    "Samoa",
    "San Marino",
    "Satellite",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "South Africa",
    "South Korea",
    "Spain",
    "Sri Lanka",
    "St Kitts & Nevis",
    "St Lucia",
    "St Vincent",
    "St. Lucia",
    "Sudan",
    "Suriname",
    "Swaziland",
    "Sweden",
    "Switzerland",
    "Syria",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Timor L' Este",
    "Togo",
    "Tonga",
    "Trinidad & Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Turks & Caicos",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "Uruguay",
    "Uzbekistan",
    "Venezuela",
    "Vietnam",
    "Virgin Islands (US)",
    "Yemen",
    "Zambia",
    "Zimbabwe",
  ],
  LANGUAGES: [
    "Arabic",
    "Chinese",
    "English",
    "French",
    "German",
    "Italian",
    "Korean",
    "Other",
    "Russian",
    "Spanish",
    "Tagalog (Philippines)",
    "Unknown",
    "Vietnamese",
  ],
  RISK_PRIORITES: [
    "Level I - High Priority",
    "Level II – Moderate Priority",
    "Level III – Low Priority",
  ],
  CODE_STATUESES: ["DNR", "DNR C", "DNR CC", "Full Code", "Unknown"],
  PHONE_US_MASK: "(000)000-0000",
  ADMIT_BENEFIT_PERIOD: "^(?:[1-9][0-9]|[1-9])$",
  ADMIT_HOSPICE_EPISODE: "^(?:[1-9][0-9]{3}|[1-9][0-9]{2}|[1-9][0-9]|[1-9])$",
  MBI_FORMAT_REGEX:
    "^[1-9](?![SLOIBZ])[A-Z](?![SLOIBZ])[0-9A-Z][0-9](?![SLOIBZ])[A-Z](?![SLOIBZ])[0-9A-Z][0-9](?![SLOIBZ])[A-Z](?![SLOIBZ])[A-Z][0-9][0-9]$",
  PHONE_REGEX: "^[(][0-9]{3}[)][0-9]{3}-[0-9]{4}$",
  EMAIL_REGEX:
    /^([!#$%&'*+-/=?^_{|}~.a-zA-Z0-9]+(\.[!#$%&'*+-/=?^_{|}~.a-zA-Z0-9]+)*)@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
  EMAIL_DOMAIN_REGEX:
    /^@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
  WEBSITE_REGEX:
    /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i,
  FAX_MASK: "(000)000-0000",
  ZIP_CODE_MASK: "00000",
  ZIP_CODE_EXTENSION_MASK: "0000",
  NPI_EXTENSION_MASK: "0000000000",
  NPI_REGEX: "^[0-9]{10}$",
  PHONE_US_PLACEHOLDER: "(xxx)xxx-xxxx",
  SSN_MASK: "000-00-0000",
  SSN_REGEX: "^[0-9]{3}-[0-9]{2}-[0-9]{4}$",
  SUBSCRIBER_NUMBER_REGEX:
    "^[1-9](?![SLOIBZsloibz])[A-Za-z](?![SLOIBZsloibz])[0-9A-Za-z][0-9](?![SLOIBZsloibz])[A-Za-z](?![SLOIBZsloibz])[0-9A-Za-z][0-9](?![SLOIBZsloibz])[A-Za-z](?![SLOIBZsloibz])[A-Za-z][0-9][0-9]$",
  SIMPLE_PHONE_MASK: "0000000000",
  SIMPLE_PHONE_REGEX: "^[0-9]{10}$",
  SANITIZIED_INPUT_REGEX:
    "^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$",
  RELATIONS_LIST: [
    "Aunt",
    "CRH Staff",
    "Community Resource",
    "Daughter",
    "Discharge Planner",
    "Father",
    "Friend",
    "Gaurdian",
    "Grandfather",
    "Grandmother",
    "Home Health",
    "Mother",
    "Neighbor",
    "Nurse",
    "Partner",
    "Physician",
    "Self",
    "Sibling",
    "Social Worker",
    "Son",
    "Spouse",
    "Uncle",
  ],
  LOCATION_TYPES: [
    "Home",
    "Assisted living facility",
    "LTC or non-skilled NF (unskilled care)",
    "Skilled nursing facility (skilled care)",
    "Inpatient hospital",
    "Inpatient hospice facility",
    "Long term care hospital",
    "Inpatient psychiatric facility",
    "Place not otherwise specified",
    "Hospice residential facility",
  ],
  LOCATION_TYPE_VALUES: [
    {
      name: "Assisted Living Facility",
    },
    {
      name: "Hospice Facility",
    },
  ],
  CURRENT_LOCATIONS: [
    {
      phone: "(541)754-3010",
      faxNumber: "(545)754-3010",
      emailAddress: "john.smith@yahoo.com",
      address: "8098 N. Fairview St. Myrtle Beach, SC 29577",
    },
    {
      phone: "(541)754-5010",
      faxNumber: "(545)754-5610",
      emailAddress: "smith.carle@yahoo.com",
      address: "89 Lawrence Street Amsterdam, NY 12010",
    },
  ],
  SPECIAL_CHAR: ["/", "(", ")", ".", ":", "-", " ", "+"],
  AWARE_Of_REFERRALS: {
    nursingFacility: "Nursing Facility",
    patient: "Patient",
    family: "Family",
    poa: "POA",
  },
  REFERRAL_CREDIT: [
    "Marketer",
    "Nurse Liaison",
    "Community Liaison",
    "Community Educator",
  ],
  LEVEL_OF_CARE_LIST: [
    "Continuous Care",
    "General Inpatient Care",
    "Respite Care",
    "Routine Home Care",
  ],
  NEW_SYMPTOMS: [
    "Agitation",
    "Anxiety",
    "Air-hunger",
    "Bleeding",
    "Dehydration",
    "Diarrhea",
    "Dyspnea",
    "Emotional Support",
    "Fever",
    "Incontinent Care",
    "Medication Administration",
    "Nausea",
    "Pain",
    "Respiratory Compromise",
    "Restlessness",
    "Seizure",
    "Vital Sign Changes",
    "Vomiting",
    "Wound Care",
    "Other",
  ],
  HOSPICE_LIST: [
    "Assisted Living Facility",
    "Home",
    "Hospice Residential Facility",
    "Inpatient - Hospice Facility",
    "Inpatient - Hospital",
    "Inpatient Psychatric Facility",
    "Long Term Care - Hospital",
    "Nursing Home",
    "Skilled Nursing Facility",
    "Unspecified",
  ],
  PALLATIVE_LIST: [
    "Assisted Living Facility",
    "Home",
    "Inpatient - Hospital",
    "Nursing Home",
    "Skilled Nursing Facility",
  ],
  LOCATION_TIMEZONE_LIST: [
    "America/Chicago",
    "America/Denver",
    "America/Indiana/Indianapolis",
    "America/Los_Angeles",
    "America/New_York",
    "America/Phoenix",
  ],
  LEVEL_OF_CARE_LABEL: "hospice",
  LOOK_UP_CONST: {
    "Referral Credit": "PC001",
    "Physicians Order": "PC002",
    "Risk Priority": "PC003",
    "First Language": "PC004",
    Religion: "PC005",
    Enthnicity: "PC006",
    "Code Status": "PC007",
    "Level Of Care": "PC008",
    "Type Of Care Location": "PC009",
    Symptoms: "PC0010",
    "Location Timezone": "PC0011",
    AWARE_OF_REFERRAL: "PC0012",
    PREFIX_VALUE: "PC0013",
    SUFFIX_VALUE: "PC0014",
    MARITAL_STATUS: "PC0015",
    REFERRAL_TYPES: "PC0016",
    RELATION_LIST: "PC0017",
    DISCHARGE_REASONS: "PC0018",
  },
  CANCELLATION_REASONS: [
    { value: "NOT_ELIGIBLE", display: "Not Eligible for Hospice" },
    { value: "ERROR", display: "Entered patient in error" },
    { value: "OTHER", display: "Other" },
  ],
  ZIP_PATTERN: "^[0-9]{5}$",
  ZIP_EXT_PATTERN: "^[0-9]{4}$",
  ADD_ICON: "md-add-circle",
  MD_ADD_ICON: "md-add",
  COMPLETED_ICON: "md-checkmark-circle",
  MD_CHECKMAR_ICON: "md-checkmark",
  IN_PROGRESS_ICON: "md-radio-button-off",
  PATIENT_CALENDAR: "Calendar Icon big White",
  EPRESCRIPE_SIDEBAR: "ePrescibe",

  PAYERS: ["Pay Medicare", "Automation medicare"],
  CERTIFY_MSG: `I certify that the accompanying information accurately reflects patient \
  assessment information for this patient and that I collected or coordinated \
  collection of this information on the dates specified. \
  To the best of my knowledge, this information was collected in accordance \
  with applicable Medicare and Medicaid requirements. I understand that reporting \
  this information is used as a basis for payments from federal funds. \
  I further understand that failure to report such information may lead to a 2 \
  percentage point reduction in the Fiscal Year payment determination. \
  I also certify that I am authorized to submit this information by this provider \
  on its behalf.`,
  ALPHANUMERIC: "^[a-zA-Z0-9 '-]+$",
  ALPHA_REGEX: "^[a-zA-Z ]*$",
  NUMBERDECIMAL_REGEX: "^-?[0-9][0-9,.]+$",
  NUMBER_REGEX: "^[0-9]+$",
  PHONE_NEW_REGEX: "^(([0-9]{3}) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$",
  MEDS_DME_CATEGORY: {
    OTHERS: "OT",
  },
  CREATININE_VALUE: "creatinine",

  containsWord(keyword: string, textToSearch: string): boolean {
    const insensitiveText: string = textToSearch.toLowerCase();
    const result: boolean = insensitiveText.includes(keyword);
    return result;
  },
  DATE_FORMAT: "MM/DD/YYYY",
  TIME_FORMAT: "HH:mm:ss",
  PAGES_ALLOWED_FOR_GLOBAL_HEADER_CHANGE: {
    assessmentType: [
      "active patients",
      "cancelled",
      "careplan",
      "discharges",
      "ordermanagement",
      "patientassessment",
      "patientchart",
      "planofcare",
      "referral",
      "referrals",
      "patient calendar",
    ],
    currentPage: [
      "assessmenthomepage",
      "sectionpage",
      "visitspage",
      "addendumnotespage",
      "newcalendarpage",
    ],
    sectionId: [
      "activity",
      "benefits",
      "consents",
      "notes",
      "profile",
      "reports",
    ],
  },
  ORDER_FACILITY_TYPES: [
    // Q5001. Unlike every other entry, the id here is the string "home" rather
    // than a numeric lookup id — that is the value the careLocationType
    // dropdown carries for Home (see LOCATION_TYPE_HOME in
    // care-location-type.ts). Without this entry getFacilityName("home")
    // dereferences undefined and throws.
    {
      id: "home",
      value: "HOME",
    },
    {
      id: "8",
      value: "ASSISTED_LIVING_FACILITY",
    },
    {
      id: "2",
      value: "NURSING_HOME",
    },
    {
      id: "7",
      value: "SKILLED_NURSING_FACILITY",
    },
    {
      id: "6",
      value: "INPATIENT_HOSPITAL",
    },
    {
      id: "5",
      value: "INPATIENT_HOSPICE_FACILITY",
    },
    {
      id: "9",
      value: "LONG_TERM_CARE_HOSPITAL",
    },
    {
      id: "11",
      value: "INPATIENT_PSYCHIATRIC_FACILITY",
    },
    {
      id: "10",
      value: "UNSPECIFIED",
    },
    {
      id: "12",
      value: "HOSPICE_RESIDENTIAL_FACILITY",
    },
  ],
};



// WEBPACK FOOTER //
// ./src/providers/common-var/common.ts